/**
 * Created by fers on 25.10.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';

interface LoadingButtonProps {
 children?: any;
 className?: string;
 disabled?: boolean;
 href?: string;
 isLoading?: boolean;
 onClick?: (...args: unknown[]) => unknown;
 onMouseOut?: (...args: unknown[]) => unknown;
 onMouseOver?: (...args: unknown[]) => unknown;
 style?: any;
 title?: string;
 type?: string;
}

export default class LoadingButton extends React.Component<LoadingButtonProps> {
    static propTypes = {
        children: PropTypes.any,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        href: PropTypes.string,
        isLoading: PropTypes.bool,
        onClick: PropTypes.func,
        onMouseOut: PropTypes.func,
        onMouseOver: PropTypes.func,
        style: PropTypes.any,
        title: PropTypes.string,
        type: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        };
    }

    // The component *may* remove itself onClick and then trying to setState, which is void as the component no longer exists
    mounted = true;
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    setLoadingStateFalse = () => {
        if (this.mounted) {
            this.setState({
                isLoading: false
            });
        }
    };

    onClick = (event) => {
        if (this.props.disabled) {
            return false;
        }

        if (this.state.isLoading || this.props.isLoading) {
            return;
        }

        let f = this.props.onClick;

        if (f) {
            if (this.mounted) {
                this.setState({
                    isLoading: true
                });
            }

            let propsOnClickResult = f(event);

            if (typeof propsOnClickResult === 'boolean') {
                this.setLoadingStateFalse();
                return propsOnClickResult;
            }
            else {
                try {
                    return Promise.resolve(propsOnClickResult).then(() => {
                        this.setLoadingStateFalse();
                    }).catch((e) => {
                        this.setLoadingStateFalse();
                        throw e;
                    });
                } catch (e) {
                    this.setLoadingStateFalse();
                    throw e;
                }
            }
        }
    };

    render() {
        let {type} = this.props;
        let elType = type === "button" || type === "submit" ? 'button' : 'div';
        let params = {
            className: this.props.className,
            disabled: this.props.disabled,
            onClick: type !== 'submit' ? this.onClick : null,
            onMouseOver: this.props.onMouseOver,
            onMouseOut: this.props.onMouseOut,
            style: this.props.style,
            title: this.props.title,
            type: type,
        };

        if (this.state.isLoading || this.props.isLoading) {
            params['style'] = {cursor: 'wait'};
        }

        let inner = this.state.isLoading || this.props.isLoading ? <span><span className="fa fa-spin fa-refresh" style={{marginRight: '.3em'}}/> {this.props.children}</span> : this.props.children;

        if (type === 'link') {
            return (<Link {...params} to={this.props.href}>{inner}</Link>);
        }

        return React.createElement(elType, params, inner);
    }
}
